module.exports = __webpack_public_path__ + "img/test_status_-1.44401eb5.png";